import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useUpdateFeideWhitelist = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, updates }) => authAPI.updateFeideWhitelist(id, updates),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(["feideWhitelists"]);
        queryClient.invalidateQueries(["feideWhitelist", variables.id]);
      },
    }
  );
};
